import styled from "@emotion/styled";

export const DrawerUploadVieoMenuContainer = styled.div`
  padding: 0 16px;
`;
